import { ButtonTeamBillingPortal } from "@/components/team/button-team-billing-portal";
import { SupportMessage } from "@/components/layout-loading/support-message";
import { useAdminMode } from "@/contexts/admin-mode-provider";
import { useTeams } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";
import { Layout } from "@/Layout";
import { redirectTo } from "@/lib/location";
import { cn } from "@/lib/utils";

export const SetupPaymentFailedPage = () => {
  const { teamSelected, isUser } = useTeams();
  const { isAdminMode } = useAdminMode();
  const { t } = useTranslation();

  if (
    !(
      teamSelected?.billingError === "payment_failed" &&
      !isUser &&
      !isAdminMode
    )
  ) {
    redirectTo("/");
    return null;
  }

  return (
    <Layout showNavMain={false} showNavSearch={false} navLinkToTheRoot={false}>
      <div className={cn("flex-col py-6 space-y-3 text-center")}>
        <h1 className="text-2xl font-bold text-primary">
          {t("setup.paymentFailed.title")}
        </h1>
        <p>{t("setup.paymentFailed.description")}</p>
        <ButtonTeamBillingPortal
          text={t("setup.paymentFailed.button")}
        />
        <SupportMessage />
      </div>
    </Layout>
  );
};
